var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"container"},[_c('el-row',[_c('el-col',[_c('header-bar')],1)],1),_c('el-row',[_c('router-view')],1),_c('el-row',[_c('footer-bar')],1)],1),_c('notification-handler')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }